import React from 'react';
import styled from 'styled-components';
import { useFormikContext } from 'formik';

import { ArrowLeft } from '@lt/components/icons-react/userflow';

import { backStep, useCigarette } from '../../context';
import { INITIAL_VALUES_FORMIK } from '../../constants';
import {
  afterDestinationStep,
  isDestinationStep,
  isMetaregionsStep,
  isPopularCountriesStep,
} from '../../utils';

export const BackWizardButton = () => {
  const {
    state: { steps, isWizard },
    dispatch,
  } = useCigarette();
  const { resetForm } = useFormikContext();
  const hide = !(isWizard && afterDestinationStep(steps));
  const isBlueButton =
    isDestinationStep(steps) || isPopularCountriesStep(steps) || isMetaregionsStep(steps);

  const handleClick = () => {
    if (isDestinationStep(steps)) {
      resetForm({ values: INITIAL_VALUES_FORMIK });
    }
    dispatch(backStep());
  };

  if (hide) return null;

  return <ArrowLeftIcon onClick={handleClick} $isBlueButton={isBlueButton} />;
};

export const ArrowLeftIcon = styled(ArrowLeft)<{ $isBlueButton?: boolean }>`
  width: 24px;
  height: 24px;
  position: fixed;
  top: 0;
  left: 0;
  margin: 20px 8px;
  z-index: 2;
  stroke: ${({ $isBlueButton }) => ($isBlueButton ? '#007AFF' : '#fff')};
`;
